var _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurgerActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.220703,
    y1: 0.5,
    x2: 10.8887,
    y2: 0.5,
    stroke: "#404040"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.220703,
    y1: 3.42188,
    x2: 10.8887,
    y2: 3.42188,
    stroke: "#404040"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.220703,
    y1: 6.34375,
    x2: 10.8887,
    y2: 6.34375,
    stroke: "#404040"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerActive);
export default __webpack_public_path__ + "static/media/burgerActive.a681cd969d745c2f7e6a0c543ccea74f.svg";
export { ForwardRef as ReactComponent };